var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"book-badge",class:'book-badge--' + _vm.info.key,attrs:{"title":_vm.info.title}},[_vm._v(_vm._s(_vm.info.short))])}
var staticRenderFns = []

export { render, staticRenderFns }